import React from "react";

const CIcon = ({ height, style }) => (
  <svg
    height={height}
    style={style}
    viewBox="0 0 66 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_2181_23029)">
      <rect
        x="2.29639"
        y="0.589355"
        width="63.3704"
        height="59"
        rx="7.18683"
        fill="#EFF1F5"
      />
      <rect
        x="2.92523"
        y="1.2182"
        width="62.1127"
        height="57.7423"
        rx="6.55798"
        stroke="#212326"
        strokeWidth="1.2577"
      />
    </g>
    <path
      d="M26.2909 34.0949C24.9208 34.0949 23.7444 33.8527 22.7618 33.3683C21.7792 32.8839 20.9765 32.2542 20.3538 31.4792C19.7448 30.7042 19.295 29.86 19.0044 28.9466C18.7138 28.0332 18.5685 27.1544 18.5685 26.3101V25.8534C18.5685 24.9124 18.7138 23.9851 19.0044 23.0717C19.3089 22.1583 19.7725 21.3279 20.3953 20.5806C21.0181 19.8333 21.8069 19.2382 22.7618 18.7953C23.7306 18.3386 24.8724 18.1102 26.1871 18.1102C27.5572 18.1102 28.7474 18.3593 29.7577 18.8576C30.7818 19.342 31.5984 20.0339 32.2073 20.9335C32.8162 21.8192 33.183 22.8572 33.3075 24.0474H30.339C30.2282 23.3554 29.9791 22.7741 29.5916 22.3036C29.218 21.8192 28.7405 21.4594 28.1592 21.2241C27.578 20.975 26.9206 20.8505 26.1871 20.8505C25.4398 20.8505 24.7755 20.9819 24.1942 21.2449C23.613 21.494 23.1286 21.8538 22.7411 22.3244C22.3536 22.7949 22.056 23.3485 21.8484 23.9851C21.6547 24.6217 21.5578 25.3275 21.5578 26.1025C21.5578 26.8499 21.6547 27.5419 21.8484 28.1785C22.056 28.8151 22.3605 29.3756 22.7618 29.86C23.1632 30.3305 23.6545 30.6973 24.2357 30.9602C24.8308 31.2232 25.5159 31.3546 26.2909 31.3546C27.4257 31.3546 28.3807 31.0779 29.1557 30.5243C29.9445 29.9569 30.422 29.168 30.5881 28.1577H33.5566C33.4183 29.2372 33.0515 30.2267 32.4564 31.1263C31.8613 32.0259 31.0448 32.7455 30.0068 33.2853C28.9688 33.825 27.7302 34.0949 26.2909 34.0949Z"
      fill="#42464C"
    />
    <defs>
      <filter
        id="filter0_d_2181_23029"
        x="0.176757"
        y="0.589355"
        width="65.49"
        height="63.3704"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-2.11963" dy="4.37037" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.258824 0 0 0 0 0.27451 0 0 0 0 0.298039 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2181_23029"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2181_23029"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default CIcon;
